import React, { useEffect, useRef } from "react";
import { useParams, useSearchParams } from "react-router-dom";

import { usePrequalificationCheckoutUrl } from "../../../services/prequalification-checkout";
import { CompletePurchaseErrorScreen } from "./components/CompletePurchaseErrorScreen";
import { ScratchRedirectScreen } from "./components/ScratchRedirectScreen";

// SGPD-547: continuation page for the in-hospital handoff QR
// (/complete-purchase/<prequalificationId>). Resolves the ScratchPay
// checkout url for the id and sends the browser there; the ScratchPay flow
// completes entirely outside the app, secured by Scratch's own OTP.
// Authenticated-only: logged-out visitors are sent to login first and
// redirected back here afterwards (see Routing.tsx / PublicRoutesContainer).
const CompletePurchaseCheckoutContainer = () => {
  const { id } = useParams<{ id: string }>();
  const [searchParams] = useSearchParams();
  // The QR encodes the id as a path segment; the query-param form covers
  // links that arrive with Branch-style appended params instead.
  const prequalificationId = id || searchParams.get("prequalificationId") || "";
  const {
    fetchCheckoutUrl,
    scratchpayUrl,
    loading,
    error,
  } = usePrequalificationCheckoutUrl();
  const startedRef = useRef(false);

  useEffect(() => {
    if (startedRef.current || !prequalificationId) return;
    startedRef.current = true;
    fetchCheckoutUrl(prequalificationId);
  }, [prequalificationId, fetchCheckoutUrl]);

  useEffect(() => {
    if (!scratchpayUrl) return;
    // replace(), not href: keeps the transition page out of Back history so
    // returning from ScratchPay doesn't re-trigger the redirect.
    window.location.replace(scratchpayUrl);
  }, [scratchpayUrl]);

  if (!prequalificationId) {
    return <CompletePurchaseErrorScreen />;
  }

  if (error && !loading) {
    return (
      <CompletePurchaseErrorScreen
        onRetry={() => fetchCheckoutUrl(prequalificationId)}
      />
    );
  }

  return <ScratchRedirectScreen />;
};

export default CompletePurchaseCheckoutContainer;
